import React from 'react';
import { Radio } from 'lucide-react';

const PHASE_LABELS = {
  profiling: 'Profilage cible',
  recommending: 'Recommandation format',
  generating: 'Génération...',
  iterating: 'Affinage document',
  done: 'Terminé',
};

const PHASE_COLORS = {
  profiling: '#8b5cf6',
  recommending: '#f59e0b',
  generating: '#3b82f6',
  iterating: '#10b981',
  done: '#6b7280',
};

const CommModeBadge = ({ phase }) => {
  const label = PHASE_LABELS[phase] || 'Communication';
  const color = PHASE_COLORS[phase] || '#8b5cf6';

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8,
      padding: '6px 14px', borderRadius: 20,
      background: `${color}15`, border: `1px solid ${color}30`,
      fontSize: 12, fontWeight: 600, color,
    }}>
      <Radio size={13} />
      <span>Mode Communication</span>
      <span style={{
        width: 4, height: 4, borderRadius: '50%',
        background: color, opacity: 0.6,
      }} />
      <span style={{ fontWeight: 400 }}>{label}</span>
    </div>
  );
};

export default CommModeBadge;
